module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 0H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2zm-8.374 16.548l-8.724 5.318c-.498.304-.902.072-.902-.52V10.652c0-.592.404-.822.902-.52l8.724 5.316c.498.304.498.798 0 1.1z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/right-square-1.js
// module id = 1389
// module chunks = 14